export default "__VITE_ASSET__vmqRZ5q5__"